import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { STATUSARRAY } from "../../_contstants/common";
import {
  clearProductSubCategoryDetails,
  closeItemSubCategoryDrawerOpen,
} from "./productsubcategorySlice";
import {
  createProductSubCategory,
  findAllActiveProductSubCategory,
  getAllProductSubCategory,
  getProductSubCategoryById,
  updateProductSubCategory,
} from "./services/productsubcategory.services";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import { Typography } from "@progress/kendo-react-common";

const CreateProductSubCategory: React.FC = () => {
  const formLoading = useAppSelector(
    (state) => state.productsubcategory.formLoading
  );
  const ProductSubCategoryDetail = useAppSelector(
    (state) => state.productsubcategory.ProductSubCategoryDetail
  );
  const FilterProductSubCategory = useAppSelector(
    (state) => state.productsubcategory.FilterProductSubCategory
  );
  const ItemsubCategoryGUID = useAppSelector((state) => state.muidrawer.data);
  const ItemCategoryList = useAppSelector(
    (state) => state.itemCategory.ItemCategoryList
  );
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);
  const itemSubCategoryDrawerOpen = useAppSelector(
    (state) => state.productsubcategory.itemSubCategoryDrawerOpen
  );
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  useEffect(() => {
    dispatch(findAllActiveItemCategory());
    return () => {
      dispatch(clearProductSubCategoryDetails());
      if (itemSubCategoryDrawerOpen) {
        dispatch(closeItemSubCategoryDrawerOpen());
      } else {
        dispatch(closed());
      }
    };
  }, []);

  useEffect(() => {
    if (ItemsubCategoryGUID) {
      dispatch(getProductSubCategoryById(ItemsubCategoryGUID));
    }
  }, [ItemsubCategoryGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!ItemsubCategoryGUID) {
        const insertpayload = {
          item_subcategory_name: values.item_subcategory_name,
          item_category_id: values.item_category_id
            ? +values.item_category_id
            : null,
          short_code: values.short_code,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(
          createProductSubCategory(insertpayload)
        );
        if (response?.meta?.requestStatus === "fulfilled") {
          if (itemSubCategoryDrawerOpen) {
            dispatch(closeItemSubCategoryDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearProductSubCategoryDetails());
          isIndirect || itemSubCategoryDrawerOpen
            ? dispatch(findAllActiveProductSubCategory())
            : dispatch(
                getAllProductSubCategory({ ...FilterProductSubCategory })
              );
        }
      } else {
        const editpayload = {
          item_subcategory_guid: ItemsubCategoryGUID,
          item_subcategory_name: values.item_subcategory_name,
          item_category_id: values.item_category_id
            ? +values.item_category_id
            : null,
          short_code: values.short_code,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateProductSubCategory(editpayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (itemSubCategoryDrawerOpen) {
            dispatch(closeItemSubCategoryDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearProductSubCategoryDetails());
          isIndirect || itemSubCategoryDrawerOpen
            ? dispatch(findAllActiveProductSubCategory())
            : dispatch(
                getAllProductSubCategory({ ...FilterProductSubCategory })
              );
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    if (itemSubCategoryDrawerOpen) {
      dispatch(closeItemSubCategoryDrawerOpen());
    } else {
      dispatch(closed());
    }
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={ProductSubCategoryDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem>
              <Typography.h4 className="m-0">
                {ItemsubCategoryGUID
                  ? "Update Product Sub Category"
                  : "Add Product Sub Category"}
              </Typography.h4>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="item_subcategory_name"
                label="Product sub category"
                placeholder="i.e. Rings"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="item_category_id"
                label="Product Category"
                placeholder="Select Category"
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={ItemCategoryList?.map((itemcategory: any) => {
                  return {
                    value: itemcategory.ID,
                    label: itemcategory.category_name,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="short_code"
                label="Short Code"
                placeholder="i.e. GJ-RNG"
                component={FormTextField}
                // validator={requiredValidator}
                // astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={ItemsubCategoryGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateProductSubCategory;
